var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSerIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.16669 10.5626C1.72252 10.5626 1.35419 10.1942 1.35419 9.75008V7.04175C1.35419 3.90008 3.91085 1.35425 7.04169 1.35425H9.75002C10.1942 1.35425 10.5625 1.72258 10.5625 2.16675C10.5625 2.61091 10.1942 2.97925 9.75002 2.97925H7.04169C4.79919 2.97925 2.97919 4.79925 2.97919 7.04175V9.75008C2.97919 10.1942 2.61085 10.5626 2.16669 10.5626Z",
    fill: "#cf3d31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 10.5626C23.3892 10.5626 23.0208 10.1942 23.0208 9.75008V7.04175C23.0208 4.79925 21.2008 2.97925 18.9583 2.97925H16.25C15.8058 2.97925 15.4375 2.61091 15.4375 2.16675C15.4375 1.72258 15.8058 1.35425 16.25 1.35425H18.9583C22.0892 1.35425 24.6458 3.90008 24.6458 7.04175V9.75008C24.6458 10.1942 24.2775 10.5626 23.8333 10.5626Z",
    fill: "#cf3d31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.9583 24.6458H17.3333C16.8891 24.6458 16.5208 24.2774 16.5208 23.8333C16.5208 23.3891 16.8891 23.0208 17.3333 23.0208H18.9583C21.2008 23.0208 23.0208 21.2008 23.0208 18.9583V17.3333C23.0208 16.8891 23.3891 16.5208 23.8333 16.5208C24.2775 16.5208 24.6458 16.8891 24.6458 17.3333V18.9583C24.6458 22.0999 22.0891 24.6458 18.9583 24.6458Z",
    fill: "#cf3d31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75002 24.6458H7.04169C3.91085 24.6458 1.35419 22.1 1.35419 18.9583V16.25C1.35419 15.8058 1.72252 15.4375 2.16669 15.4375C2.61085 15.4375 2.97919 15.8058 2.97919 16.25V18.9583C2.97919 21.2008 4.79919 23.0208 7.04169 23.0208H9.75002C10.1942 23.0208 10.5625 23.3892 10.5625 23.8333C10.5625 24.2775 10.1942 24.6458 9.75002 24.6458Z",
    fill: "#cf3d31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20832 12.3284C10.9314 12.3284 12.3283 10.9315 12.3283 9.20838C12.3283 7.48525 10.9314 6.08838 9.20832 6.08838C7.48519 6.08838 6.08832 7.48525 6.08832 9.20838C6.08832 10.9315 7.48519 12.3284 9.20832 12.3284Z",
    fill: "#cf3d31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.12498 19.9117C9.2498 19.9117 10.1617 18.9999 10.1617 17.875C10.1617 16.7502 9.2498 15.8384 8.12498 15.8384C7.00016 15.8384 6.08832 16.7502 6.08832 17.875C6.08832 18.9999 7.00016 19.9117 8.12498 19.9117Z",
    fill: "#cf3d31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.875 10.1617C18.9998 10.1617 19.9117 9.24987 19.9117 8.12505C19.9117 7.00023 18.9998 6.08838 17.875 6.08838C16.7502 6.08838 15.8383 7.00023 15.8383 8.12505C15.8383 9.24987 16.7502 10.1617 17.875 10.1617Z",
    fill: "#cf3d31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7917 19.9116C18.5148 19.9116 19.9117 18.5148 19.9117 16.7916C19.9117 15.0685 18.5148 13.6716 16.7917 13.6716C15.0686 13.6716 13.6717 15.0685 13.6717 16.7916C13.6717 18.5148 15.0686 19.9116 16.7917 19.9116Z",
    fill: "#cf3d31"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon02);
export default __webpack_public_path__ + "static/media/ser-icon02.4091ff779c9e3031db3360a575fd67ef.svg";
export { ForwardRef as ReactComponent };